import React from 'react';

const HistoryItem = ({ year, title, image, description }) => {
  return (
    <div className="col-md-3 col-sm-6 history-list text-center">
      <span className="top-img">
        <img src={image} className="img-responsive" alt={`${title}-image`} />
      </span>
      <div className="history-list-middle">
        <div className="white-circle">
          <div className="white-circle-border">
            <div className="yellow-circle">{year}</div>
          </div>
        </div>
        <span className="year-circle"></span>
      </div>
      <h5>{title}</h5>
      <p className="line-height26">{description}</p>
    </div>
  );
};

// Main CompanyHistory component
const CompanyHistory = () => {
  const historyData = [
    {
      year: '1982',
      title: 'Foundation of Anjali Enterprises',
      image: 'images/humble-begin-img.png',
      description: 'Anjali Enterprises was founded with a vision to provide exceptional service and solutions in the construction and renovation industry.'
    },
    {
      year: '1985',
      title: 'Expansion into Aluminium Glass Works',
      image: 'images/headquarter-img.png',
      description: 'The company expanded into the aluminium glass works sector, offering innovative solutions for residential and commercial buildings.'
    },
    {
      year: '2010',
      title: 'Introduction of ACP Cladding',
      image: 'images/opening-loc-img.png',
      description: 'We introduced ACP (Aluminium Composite Panel) cladding, transforming the look and durability of buildings with modern and high-quality facades.'
    },
    {
      year: '2017',
      title: 'Leadership in Soundproof Glass Installations',
      image: 'images/coverage-img.png',
      description: 'Anjali Enterprises became a leader in soundproof glass installations, catering to clients seeking comfort and noise reduction in urban areas.'
    },
  ];

  return (
    <section className="history-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h3>COMPANY HISTORY</h3>
          </div>

          {/* Render History Items dynamically */}
          {historyData.map((item, index) => (
            <HistoryItem
              key={index}
              year={item.year}
              title={item.title}
              image={item.image}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyHistory;
